<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <g fill-rule="evenodd" fill="currentColor">
    <path fill-rule="nonzero" d="M16 30a14 14 0 1 0 0-28 14 14 0 0 0 0 28Zm0 2a16 16 0 1 1 0-32 16 16 0 0 1 0 32Z"/>
    <path d="M2 16h28v1H2z"/>
    <path d="M16.5 1.5v29h-1v-29z"/>
    <path fill-rule="nonzero" d="m12.14 1 .86.84c-6.51 9.48-6.51 18.84 0 28.32l-.86.84c-6.85-9.96-6.85-20.04 0-30Zm7.72 0-.86.84c6.51 9.48 6.51 18.84 0 28.32l.86.84c6.85-9.96 6.85-20.04 0-30Z"/>
    <path fill-rule="nonzero" d="m4 8.22.67-.72c7.58 5.43 15.08 5.43 22.66 0l.67.72c-7.97 5.7-16.03 5.7-24 0Zm0 16.56.67.72c7.58-5.43 15.08-5.43 22.66 0l.67-.72c-7.97-5.7-16.03-5.7-24 0Z"/>
  </g>
</svg>